// Module
var code = `<h3>Данные за выбранный период</h3>
<br>
<p>Добавление оффера: {{ data.add }}</p>
<p>Уника показы оффера: {{ data.uniq_see }}</p>
<p>Всего показы оффера: {{ data.see }}</p>
<p>Покупки: {{ data.purchase_count }}</p>
<p>Цена оффера: {{ data.default_price }}</p>
<p>Прибыль: {{ data.total_profit | number:2 }}</p>
<p>Конверсия: {{ data.conversion | number:2 }}%</p>
<p>Доход на игрока: {{ data.profit_per_user | number:2 }}</p>

`;
// Exports
module.exports = code;